import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import EntityPermissions from "../../interfaces/entityPermissions";

interface EntityPermissionsState {
    entityPermissions: EntityPermissions[];
};

const initialState: EntityPermissionsState = {
    entityPermissions: []
};

export const entityPermissionsSlice = createSlice({
    name: 'entityPermissions',
    initialState,
    reducers: {
        loadEntityPermissions: (state, action: PayloadAction<EntityPermissions[]>) => {
            state.entityPermissions = action.payload;
        },
    },
});

export const { loadEntityPermissions } = entityPermissionsSlice.actions;

export default entityPermissionsSlice.reducer;